import { Card, CardContent, CardHeader, Divider } from "@mui/material";
import AbstractForm from "./AbstractForm";
import BenefitForm from "./BenefitForm";
import LocationForm from "./LocationForm";
import ObjectiveForm from "./ObjectiveForm";
import ProcedureForm from "./ProcedureForm";

export default function ProjectSettingInformation() {
    return (
        <Card variant="outlined">
            <CardHeader title="Information"></CardHeader>
            <Divider variant="middle" />
            <CardContent>
                <AbstractForm id="abstract" />
                <ObjectiveForm id="objective" />
                <ProcedureForm id="prodecure" />
                <BenefitForm id="benefit" />
                <LocationForm id="location" />
            </CardContent>
        </Card>
    );
}
